import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/index';
import type { MuteItem, NotificationCategory } from '@/types/notificationPreferences/types';

const selectState = (state: RootState) => state.notificationPreferences;

export const selectPreferencesLoading = (state: RootState) => selectState(state).loading;
export const selectPreferencesSaving = (state: RootState) => selectState(state).saving;
export const selectPreferencesError = (state: RootState) => selectState(state).error;
export const selectPreferencesView = (state: RootState) => selectState(state).view;
const selectMutes = (state: RootState): readonly MuteItem[] => selectState(state).view?.mutes ?? [];

export const selectQuietHours = createSelector(selectPreferencesView, (view) => ({
  start: view?.preferences.quietHoursStart ?? null,
  end: view?.preferences.quietHoursEnd ?? null,
}));

// Memoiza no array de mutes (não no view inteiro). Mudanças de quietHours
// não invalidam o Set.
export const selectMutedCategories = createSelector(
  selectMutes,
  (mutes): Set<NotificationCategory> =>
    new Set(
      mutes
        .filter(
          (m): m is MuteItem & { category: NotificationCategory } =>
            m.scope === 'CATEGORY' && m.category !== null,
        )
        .map((m) => m.category),
    ),
);

export const selectMutedEntities = createSelector(selectMutes, (mutes) =>
  mutes.filter((m) => m.scope === 'ENTITY'),
);

export const selectCategoryMuteId = (category: NotificationCategory) =>
  createSelector(
    selectMutes,
    (mutes) => mutes.find((m) => m.scope === 'CATEGORY' && m.category === category)?.id ?? null,
  );
